import { Button, View, Text } from "react-native";
import { style_templates } from "../config_variables/styles";
import Icon2 from "react-native-vector-icons/FontAwesome";
import { variables } from "../config_variables/variables";
import convertNumberToCurrency from "../utils/convertNumberToCurrency";
import getIconColor from "../utils/getIconColor";

const iconSizeLotListCard = 13
  const iconSize = variables.isDesktop ? 12 : 30

const LotDetailRow = (props) => {
      const valuation_chevron_icon = props.diff > 0 ? "chevron-up" : "chevron-down"
      const valuation_chevron_icon_color = props.diff > 0 ? "#008000" : "#f08080"

      return (
            <>
                  <View style={style_templates.lot_card_template_text_container_row_box_left}>                               
                        <Text style={style_templates.lot_card_template_text_labels}><Icon2 name={props.icon} size={iconSizeLotListCard} color="#cd5c5c" /> {props.name}</Text>
                  </View>
                  <View style={style_templates.lot_card_template_text_container_row_box_right}>
                        <Text style={style_templates.lot_card_template_text_labels_large}>
                              {/* {isNan(props.value) ? props.value : convertNumberToCurrency(props.value)} */}
                               {/* {convertNumberToCurrency(props.value)} */}
                              { ( props.name.includes('Corner Lot') ||  props.name.includes('Irregular Lot') )  &&  (
                                          props.value && (
                                                <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('boolean',props.value)} />
                                          )
                              )}
                              {  !props.name.includes('Corner Lot') &&  !props.name.includes('Irregular Lot')   &&  (
                                          props.value
                              )}
                               
                              {props.name.includes(' Val') && (
                                    <>
                                          <View style={style_templates.custom_left_padding}>
                                                <Icon2 name={valuation_chevron_icon} size={iconSize} color={valuation_chevron_icon_color} />
                                          </View>
                                          <View style={style_templates.custom_left_padding}>
                                                <Text style={style_templates.lot_card_template_text_labels}>{convertNumberToCurrency(props.diff)} </Text>
                                          </View>
                                    </>
                              )}                                          

                        </Text>
                  </View>
                  </>
  );
};

export default LotDetailRow;
